// extracted by mini-css-extract-plugin
export var dropResultWrap = "style-module--dropResultWrap--3FD9c";
export var dropResultWrap_file = "style-module--dropResultWrap_file--Lchuz";